import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`

export const Heading = styled.h5`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0 0 16px;

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const List = styled.div`
  border: 1px solid #ADADAD;
  padding: 12px;
  border-radius: 4px;
`
export const OptionText = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${darkColor};
  margin: 0;
`